// src/components/NotFoundRedirect.js (or wherever you have it)

import React from 'react';
import { Navigate } from 'react-router-dom';

const NotFoundRedirect = () => {
  // For any path that doesn't match, this component will be rendered.
  // We simply want to redirect the user to the "/home" page.
  // The 'replace' prop is important: it replaces the bad URL in the
  // browser's history, so the user can't click the "back" button
  // and end up on the non-existent page again.

  return <Navigate to="/home" replace />;
};

export default NotFoundRedirect;